<form [formGroup]="searchForm">

  <ng-container *ngFor="let filterGroup of filterDisplay">
    <div class="search-section">
      <ng-container *ngFor="let filter of filterGroup">
        <ng-container *ngTemplateOutlet="getFilterTemplate(filter)"></ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #businessUnitTemplate>
    <mat-form-field matTooltip="Select a Business Unit from the list"
      [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
      <mat-label i18n="@@type.Asset.businessUnit">Business Unit</mat-label>
      <mat-select formControlName="businessUnit" id="businessUnitFilterInput"
        (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="businessUnitFilter"
        (ngModelChange)="businessUnitChanged($event)" #businessUnitFilterInput placeholder="Business Unit"
        [compareWith]="businessUnitCompare">
        <mat-option>Any</mat-option>
        <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
          {{businessUnit?.buId}} - {{businessUnit?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <ng-template #costCentreTemplate>
    <mat-form-field matTooltip="Select a Cost Centre from the list"
      [matTooltipDisabled]="disabledTooltip(this.costCentre)">
      <mat-label i18n="@@type.Asset.costCentre">Cost Centre</mat-label>
      <mat-select formControlName="costCentre" id="costCentreFilterInput" (ngModelChange)="costCentreChanging($event)"
        [(ngModel)]="costCentreFilter" (ngModelChange)="costCentreChanged($event)" #costCentreFilterInput
        placeholder="Cost Centre" [compareWith]="costCentreCompare">
        <mat-option>Any</mat-option>
        <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
          {{costCentre?.ccId}} - {{costCentre?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <ng-template #locationTemplate>
    <mat-form-field matTooltip="Location"
      [matTooltipDisabled]="disabledTooltip(this.location)">
      <mat-label i18n="@@type.Asset.location">Location</mat-label>
      <input matInput formControlName="location" id="locationFilterInput" (ngModelChange)="locationChanging($event)"
        [(ngModel)]="locationFilter" (ngModelChange)="locationChanged($event)" #locationFilterInput maxlength="255"
        placeholder="Location">
    </mat-form-field>
  </ng-template>
  
  <ng-template #purchaseDateGreaterThanOrEqualToTemplate>
    <mat-form-field matTooltip="Purchase Date From"
      [matTooltipDisabled]="disabledTooltip(this.purchaseDateGreaterThanOrEqualTo)">
      <mat-label i18n="@@type.Asset.purchaseDateGreaterThanOrEqualTo">Purchase Date From</mat-label>
      <input matInput formControlName="purchaseDateGreaterThanOrEqualTo" id="purchaseDateGreaterThanOrEqualToFilterInput"
        (ngModelChange)="purchaseDateGreaterThanOrEqualToChanging($event)"
        [(ngModel)]="purchaseDateGreaterThanOrEqualToFilter"
        (ngModelChange)="purchaseDateGreaterThanOrEqualToChanged($event)" #purchaseDateGreaterThanOrEqualToFilterInput
        [matDatepicker]="purchaseDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
        placeholder="Purchase Date From">
      <mat-datepicker-toggle matSuffix [for]="purchaseDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #purchaseDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
    </mat-form-field>
  </ng-template>
  
  <ng-template #purchaseDateLessThanOrEqualToTemplate>
    <mat-form-field matTooltip="Purchase Date To"
      [matTooltipDisabled]="disabledTooltip(this.purchaseDateLessThanOrEqualTo)">
      <mat-label i18n="@@type.Asset.purchaseDateLessThanOrEqualTo">Purchase Date To</mat-label>
      <input matInput formControlName="purchaseDateLessThanOrEqualTo" id="purchaseDateLessThanOrEqualToFilterInput"
        (ngModelChange)="purchaseDateLessThanOrEqualToChanging($event)"
        [(ngModel)]="purchaseDateLessThanOrEqualToFilter"
        (ngModelChange)="purchaseDateLessThanOrEqualToChanged($event)" #purchaseDateLessThanOrEqualToFilterInput
        [matDatepicker]="purchaseDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
        placeholder="Purchase Date To">
      <mat-datepicker-toggle matSuffix [for]="purchaseDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #purchaseDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
    </mat-form-field>
  </ng-template>
  
  <ng-template #purchasePriceGreaterThanOrEqualToTemplate>
    <mat-form-field matTooltip="Purchase Price From"
      [matTooltipDisabled]="disabledTooltip(this.purchasePriceGreaterThanOrEqualTo)">
      <mat-label i18n="@@type.Asset.purchasePriceGreaterThanOrEqualTo">Purchase Price From</mat-label>
      <input matInput formControlName="purchasePriceGreaterThanOrEqualTo" id="purchasePriceGreaterThanOrEqualToFilterInput"
        (ngModelChange)="purchasePriceGreaterThanOrEqualToChanging($event)"
        [(ngModel)]="purchasePriceGreaterThanOrEqualToFilter"
        (ngModelChange)="purchasePriceGreaterThanOrEqualToChanged($event)" #purchasePriceGreaterThanOrEqualToFilterInput
        type="number" placeholder="Purchase Price From">
    </mat-form-field>
  </ng-template>
  
  <ng-template #purchasePriceLessThanOrEqualToTemplate>
    <mat-form-field matTooltip="Purchase Price To"
      [matTooltipDisabled]="disabledTooltip(this.purchasePriceLessThanOrEqualTo)">
      <mat-label i18n="@@type.Asset.purchasePriceLessThanOrEqualTo">Purchase Price To</mat-label>
      <input matInput formControlName="purchasePriceLessThanOrEqualTo" id="purchasePriceLessThanOrEqualToFilterInput"
        (ngModelChange)="purchasePriceLessThanOrEqualToChanging($event)"
        [(ngModel)]="purchasePriceLessThanOrEqualToFilter"
        (ngModelChange)="purchasePriceLessThanOrEqualToChanged($event)" #purchasePriceLessThanOrEqualToFilterInput
        type="number" placeholder="Purchase Price To">
    </mat-form-field>
  </ng-template>

  <ng-template #assetTypeTemplate>
    <mat-form-field matTooltip="Select a Asset Type from the list"
      [matTooltipDisabled]="disabledTooltip(this.assetType)">
      <mat-label i18n="@@type.Asset.assetType">Asset Type</mat-label>
      <mat-select formControlName="assetType" id="assetTypeFilterInput" (ngModelChange)="assetTypeChanging($event)"
        [(ngModel)]="assetTypeFilter" (ngModelChange)="assetTypeChanged($event)" #assetTypeFilterInput
        placeholder="Asset Type" [compareWith]="assetTypeCompare">
        <mat-option>Any</mat-option>
        <mat-option *ngFor="let assetType of assetTypeSelectionList" [value]="assetType">
          {{assetType?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
  
  <ng-template #manufacturerTemplate>
    <mat-form-field matTooltip="Manufacturer"
      [matTooltipDisabled]="disabledTooltip(this.manufacturer)">
      <mat-label i18n="@@type.Asset.manufacturer">Manufacturer</mat-label>
      <input matInput formControlName="manufacturer" id="manufacturerFilterInput"
        (ngModelChange)="manufacturerChanging($event)" [(ngModel)]="manufacturerFilter"
        (ngModelChange)="manufacturerChanged($event)" #manufacturerFilterInput maxlength="255"
        placeholder="Manufacturer">
    </mat-form-field>
  </ng-template>
  
  <ng-template #modelTemplate>
    <mat-form-field matTooltip="Model" [matTooltipDisabled]="disabledTooltip(this.model)">
      <mat-label i18n="@@type.Asset.model">Model</mat-label>
      <input matInput formControlName="model" id="modelFilterInput" (ngModelChange)="modelChanging($event)"
        [(ngModel)]="modelFilter" (ngModelChange)="modelChanged($event)" #modelFilterInput maxlength="255"
        placeholder="Model">
    </mat-form-field>
  </ng-template>
  
  <ng-template #descriptionTemplate>
    <mat-form-field matTooltip="Description"
      [matTooltipDisabled]="disabledTooltip(this.description)">
      <mat-label i18n="@@type.Asset.description">Description</mat-label>
      <input matInput formControlName="description" id="descriptionFilterInput"
        (ngModelChange)="descriptionChanging($event)" [(ngModel)]="descriptionFilter"
        (ngModelChange)="descriptionChanged($event)" #descriptionFilterInput maxlength="2000" placeholder="Description">
    </mat-form-field>
  </ng-template>
  
  <ng-template #identityReferenceTemplate>
    <mat-form-field matTooltip="Identity Reference"
      [matTooltipDisabled]="disabledTooltip(this.identityReference)">
      <mat-label i18n="@@type.Asset.identityReference">Identity Reference</mat-label>
      <input matInput formControlName="identityReference" id="identityReferenceFilterInput"
        (ngModelChange)="identityReferenceChanging($event)" [(ngModel)]="identityReferenceFilter"
        (ngModelChange)="identityReferenceChanged($event)" #identityReferenceFilterInput maxlength="255"
        placeholder="Identity Reference">
    </mat-form-field>
  </ng-template>
  
  <ng-template #statusTemplate>
    <mat-form-field matTooltip="Select a Status from the list" [matTooltipDisabled]="disabledTooltip(this.status)">
      <mat-label i18n="@@type.Asset.status">Status</mat-label>
      <mat-select formControlName="status" id="statusFilterInput"              
          (ngModelChange)="statusChanging($event)" [(ngModel)]="statusFilter"              
          (ngModelChange)="statusChanged($event)" #statusFilterInput              
          placeholder="Status">
        <mat-option>Any</mat-option>
        <mat-option *ngFor="let status of statusSelectionList" [value]="status.code">
          {{status.meaning}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <ng-template #createdByTemplate>
    <mat-form-field matTooltip="Created By"
      [matTooltipDisabled]="disabledTooltip(this.createdBy)">
      <mat-label i18n="@@type.Asset.createdBy">Created By</mat-label>
      <input matInput formControlName="createdBy" id="createdByFilterInput" (ngModelChange)="createdByChanging($event)"
        [(ngModel)]="createdByFilter" (ngModelChange)="createdByChanged($event)" #createdByFilterInput maxlength="255"
        placeholder="Created By">
    </mat-form-field>
  </ng-template>
  
  <ng-template #createdDateGreaterThanOrEqualToTemplate>
    <mat-form-field matTooltip="Created Date From"
      [matTooltipDisabled]="disabledTooltip(this.createdDateGreaterThanOrEqualTo)">
      <mat-label i18n="@@type.Asset.createdDateGreaterThanOrEqualTo">Created Date From</mat-label>
      <input matInput formControlName="createdDateGreaterThanOrEqualTo" id="createdDateGreaterThanOrEqualToFilterInput"
        (ngModelChange)="createdDateGreaterThanOrEqualToChanging($event)"
        [(ngModel)]="createdDateGreaterThanOrEqualToFilter"
        (ngModelChange)="createdDateGreaterThanOrEqualToChanged($event)" #createdDateGreaterThanOrEqualToFilterInput
        [matDatepicker]="createdDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
        placeholder="Created Date From">
      <mat-datepicker-toggle matSuffix [for]="createdDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #createdDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
    </mat-form-field>
  </ng-template>
  
  <ng-template #createdDateLessThanOrEqualToTemplate>
    <mat-form-field matTooltip="Created Date To"
      [matTooltipDisabled]="disabledTooltip(this.createdDateLessThanOrEqualTo)">
      <mat-label i18n="@@type.Asset.createdDateLessThanOrEqualTo">Created Date To</mat-label>
      <input matInput formControlName="createdDateLessThanOrEqualTo" id="createdDateLessThanOrEqualToFilterInput"
        (ngModelChange)="createdDateLessThanOrEqualToChanging($event)" [(ngModel)]="createdDateLessThanOrEqualToFilter"
        (ngModelChange)="createdDateLessThanOrEqualToChanged($event)" #createdDateLessThanOrEqualToFilterInput
        [matDatepicker]="createdDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
        placeholder="Created Date To">
      <mat-datepicker-toggle matSuffix [for]="createdDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #createdDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
    </mat-form-field>
  </ng-template>

  <ng-template #updatedByTemplate>
      <mat-form-field matTooltip="Updated By"
        [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
        <mat-label i18n="@@type.Asset.updatedBy">Updated By</mat-label>
        <input matInput formControlName="updatedBy" id="updatedByFilterInput" (ngModelChange)="updatedByChanging($event)"
          [(ngModel)]="updatedByFilter" (ngModelChange)="updatedByChanged($event)" #updatedByFilterInput maxlength="255"
          placeholder="Updated By">
      </mat-form-field>
    </ng-template>
    
    <ng-template #updatedDateGreaterThanOrEqualToTemplate>
      <mat-form-field matTooltip="Updated Date From"
        [matTooltipDisabled]="disabledTooltip(this.updatedDateGreaterThanOrEqualTo)">
        <mat-label i18n="@@type.Asset.updatedDateGreaterThanOrEqualTo">Updated Date From</mat-label>
        <input matInput formControlName="updatedDateGreaterThanOrEqualTo" id="updatedDateGreaterThanOrEqualToFilterInput"
          (ngModelChange)="updatedDateGreaterThanOrEqualToChanging($event)"
          [(ngModel)]="updatedDateGreaterThanOrEqualToFilter"
          (ngModelChange)="updatedDateGreaterThanOrEqualToChanged($event)" #updatedDateGreaterThanOrEqualToFilterInput
          [matDatepicker]="updatedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
          placeholder="Updated Date From">
        <mat-datepicker-toggle matSuffix [for]="updatedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #updatedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </ng-template>
    
    <ng-template #updatedDateLessThanOrEqualToTemplate>
      <mat-form-field matTooltip="Updated Date To"
        [matTooltipDisabled]="disabledTooltip(this.updatedDateLessThanOrEqualTo)">
        <mat-label i18n="@@type.Asset.updatedDateLessThanOrEqualTo">Updated Date To</mat-label>
        <input matInput formControlName="updatedDateLessThanOrEqualTo" id="updatedDateLessThanOrEqualToFilterInput"
          (ngModelChange)="updatedDateLessThanOrEqualToChanging($event)" [(ngModel)]="updatedDateLessThanOrEqualToFilter"
          (ngModelChange)="updatedDateLessThanOrEqualToChanged($event)" #updatedDateLessThanOrEqualToFilterInput
          [matDatepicker]="updatedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
          placeholder="Updated Date To">
        <mat-datepicker-toggle matSuffix [for]="updatedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #updatedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
      </mat-form-field>
    </ng-template>

    <ng-template #routineMaintenanceDueSoonTemplate>
      <mat-form-field matTooltip="Select an option from the list"
        [matTooltipDisabled]="disabledTooltip(this.routineMaintenanceDueSoon)">
        <mat-label i18n="@@type.Asset.routineMaintenanceDueSoon">Routine Maintenance Due Soon</mat-label>
        <mat-select formControlName="routineMaintenanceDueSoon" id="routineMaintenanceDueSoonFilterInput" (ngModelChange)="routineMaintenanceDueSoonChanging($event)"
          [(ngModel)]="routineMaintenanceDueSoonFilter" (ngModelChange)="routineMaintenanceDueSoonChanged($event)" #routineMaintenanceDueSoonFilterInput
          placeholder="Cost Centre">
          <mat-option>Any</mat-option>
          <mat-option [value]="true">Due Soon/Overdue</mat-option>
          <mat-option [value]="false">Not Due</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>

  <ng-template #allTagsTemplate>
    <div class="chip-field">
      <span>
        All Of -
        <mat-chip-list #allTagsChips>
          <mat-chip *ngFor="let tag of allTagsFilter" [removable]="false" (click)="removeAllTag(tag)" color="primary">
            {{tag}}
          </mat-chip>
        </mat-chip-list>
      </span>
  
      <mat-form-field matTooltip="Search for Assets containing all of these tags"
        [matTooltipDisabled]="disabledTooltip(this.allTags)" class="search-filter-wide">
        <mat-label i18n="@@type.Asset.containsAllTags">Contains All Tags</mat-label>
        <input matInput [matAutocomplete]="allTagsAutocomplete" [matChipInputFor]="allTagsChips"
          formControlName="allTags" (keydown.enter)="selectedAllTagEnter()" id="allTags" #allTags
          placeholder="Contains All Tags" [(ngModel)]="allTagsInputField"
          (click)="allTagsAutocompleteTrigger.openPanel()">
        <mat-autocomplete id="allTagsAutocomplete" #allTagsAutocomplete (optionSelected)="selectedAllTagClick($event)">
          <mat-option *ngFor="let tag of allTagsSelectionList | async" [value]="tag">
            {{tag}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </ng-template>

  <ng-template #anyTagsTemplate>
    <div class="chip-field">
      <span>
        Any Of -
        <mat-chip-list #anyTagsChips>
          <mat-chip *ngFor="let tag of anyTagsFilter" [removable]="false" (click)="removeAnyTag(tag)" color="primary">
            {{tag}}
          </mat-chip>
        </mat-chip-list>
      </span>
  
      <mat-form-field matTooltip="Search for Assets containing at least one of these tags"
        [matTooltipDisabled]="disabledTooltip(this.anyTags)" class="search-filter-wide">
        <mat-label i18n="@@type.Asset.containsAnyTags">Contains Any Tags</mat-label>
        <input matInput [matAutocomplete]="anyTagsAutocomplete" [matChipInputFor]="anyTagsChips"
          formControlName="anyTags" (keydown.enter)="selectedAnyTagEnter()" id="anyTags" #anyTags
          placeholder="Contains Any Tags" [(ngModel)]="anyTagsInputField"
          (click)="anyTagsAutocompleteTrigger.openPanel()">
        <mat-autocomplete id="anyTagsAutocomplete" #anyTagsAutocomplete (optionSelected)="selectedAnyTagClick($event)">
          <mat-option *ngFor="let tag of anyTagsSelectionList | async" [value]="tag">
            {{tag}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </ng-template>

</form>